import { render, staticRenderFns } from "./documentAttributeReport.vue?vue&type=template&id=2b14dc02&scoped=true"
import script from "./documentAttributeReport.vue?vue&type=script&lang=js"
export * from "./documentAttributeReport.vue?vue&type=script&lang=js"
import style0 from "./documentAttributeReport.vue?vue&type=style&index=0&id=2b14dc02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b14dc02",
  null
  
)

export default component.exports